module.exports = __webpack_public_path__ + "099dbe04aba2550a3bb3fd5ff1216c60.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/chevron_down.svg
// module id = 43
// module chunks = 0